/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseSupplementalDocumentComparingData } from './get-trustdock-verifications200-response-supplemental-document-comparing-data';
// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner } from './get-trustdock-verifications200-response-supplemental-document-records-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseSupplementalDocumentResult } from './get-trustdock-verifications200-response-supplemental-document-result';

/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseSupplementalDocument
 */
export interface GetTrustdockVerifications200ResponseSupplementalDocument {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'publicId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'idForHelper': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'state': GetTrustdockVerifications200ResponseSupplementalDocumentStateEnum;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseSupplementalDocumentResult}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'result': GetTrustdockVerifications200ResponseSupplementalDocumentResult | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'acceptedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'plansSelectedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'documentSubmittedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'preparedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseSupplementalDocumentComparingData}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'comparingData': GetTrustdockVerifications200ResponseSupplementalDocumentComparingData;
    /**
     * 
     * @type {Array<GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner>}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'records': Array<GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner> | null;
}

export const GetTrustdockVerifications200ResponseSupplementalDocumentStateEnum = {
    accepted: 'accepted',
    plansSelected: 'plans_selected',
    documentSubmitted: 'document_submitted',
    inProgress: 'in_progress',
    verified: 'verified'
} as const;

export type GetTrustdockVerifications200ResponseSupplementalDocumentStateEnum = typeof GetTrustdockVerifications200ResponseSupplementalDocumentStateEnum[keyof typeof GetTrustdockVerifications200ResponseSupplementalDocumentStateEnum];


